<template>
<div class="license-info" :class="isActivated">
	<ConfirmModal @confirm="deauthorizeHardware" ref="deauthorizeModal" title="De-Authorize Hardware" message="Are you sure you want to de-authorize this license? You will be able to activate it on different hardware."></ConfirmModal>

	<header>
		<img src="@/assets/img/kolkin-sos-icon.png" />
		<b>{{license.product_name}}</b>
	</header>
    <p><b>Version:</b>  {{license.version}}</p>
	<p><b>Licensed to:</b>  {{license.licensee}}</p>
	<p v-if="license.activated != 't'"><b>Activation Code:</b> {{license.activation_code}}</p>

	<button v-if="license.activated == 't' && license.hardware_fingerprint" @click="deauthorizeClick" class="deauthorize-button">
        <i class="icon icon-lock-open"></i> De-Authorize Hardware
    </button>

    <p>Software Download</p>
    <div class="downloads">
        <a :class="{'active':isWindows}" :href="'/download/sos.msi?fingerprint='+fingerprint" download><i class="icon icon-brand-microsoft"></i> Windows</a>
        <a @click="macDownloadClick" :id="'macButton'+license.activation_code" :class="{'active':isMac}"><i class="icon icon-brand-apple"></i> Mac</a>
        <Popper ref="macDownloads" :target_id="'macButton'+license.activation_code" :placement="'bottom-start'" :append_to_body="true" :offset="[0,2]">
        	<div class="dropdown-menu mac-downloads">
         		<a :href="'/download/arm/sos.dmg?fingerprint='+fingerprint" download><i class="icon icon-download"></i> Apple Silicon </a>
           		<a :href="'/download/sos.dmg?fingerprint='+fingerprint" download><i class="icon icon-download"></i> Intel </a>
        	</div>
        </Popper>
    </div>

	<button v-if="license.is_recurring=='t'" @click="$router.push({name:'license-invoice',params:{license:license.license_uuid}})" class="payment-button">
        Payment Details <i class="icon icon-chevron-right"></i>
    </button>
    <span v-if="license.trial=='t'" class="payment-button">
        Trial License
    </span>
</div>
</template>

<script>

import Popper from "@/../submodules/vue-base/components/Popper";
import ConfirmModal from "@/../submodules/vue-base/components/ConfirmModal";
import axios from "axios";

export default {
    name: "License",

    components: {
    	Popper,
        ConfirmModal
    },

    props: {
        license: {},
        isMac: {
            type: Boolean,
            default: false
        },
        isWindows: {
            type: Boolean,
            default: false
        },
        fingerprint: {
            type: String,
            default: ""
        }
    },

    methods: {
    	macDownloadClick(){
			this.$refs.macDownloads.toggle();
     	},

        deauthorizeClick() {
            this.$refs.deauthorizeModal.open();
        },

        deauthorizeHardware() {
            var temp = this;

            // Get the user's local_uuid from Vuex store
            var local_uuid = this.$store.getters.user.kolkinid || "";

            axios.post("/product/deauthorize", {
                license_uuid: this.license.license_uuid,
                local_uuid: local_uuid
            }).then(function () {
                // Reload licenses to show updated status
                temp.$store.dispatch("loadLicenses");
            }).catch(function (error) {
                console.error("Failed to deauthorize hardware:", error);
                var errorMessage = "Failed to deauthorize hardware.";
                if (error.response && error.response.data && error.response.data.error) {
                    errorMessage = error.response.data.error;
                }
                alert(errorMessage);
            });
        }
    },

    computed: {
        isActivated() {
            return {
                'grayout': this.license.activated == 't',
            };
        }
    },
}
</script>
